import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type Cart } from "./types";

export default {
  add: (apiInfo: ModuleApiInfo, args: Cart.Api.AddRequest): Promise<HttpApiResponse<Cart.Api.AddResponse>> =>
    api.put(apiInfo, `/api/site/v1/modules/cart`, args),

  init: (apiInfo: ModuleApiInfo, args: Cart.Api.InitRequest): Promise<HttpApiResponse<Cart.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/cart`, args),
  checkout: (apiInfo: ModuleApiInfo, args: Cart.Api.CheckoutRequest): Promise<HttpApiResponse<void>> =>
    api.post(apiInfo, `/api/site/v1/modules/cart/checkout`, args),
  remove: (apiInfo: ModuleApiInfo, productId: string): Promise<HttpApiResponse<void>> =>
    api.delete(apiInfo, `/api/site/v1/modules/cart/${productId}`)
};
